import { render, staticRenderFns } from "./ProposalsEdit.vue?vue&type=template&id=8d37b7f0&scoped=true&"
import script from "./ProposalsEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProposalsEdit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProposalsEdit.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./ProposalsEdit.vue?vue&type=style&index=3&id=8d37b7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d37b7f0",
  null
  
)

export default component.exports